import React from 'react';

import IotDevices from '../components/iot-devices';

class IotDevicesPage extends React.Component {

    render() {
        return (
            <div>
                <IotDevices/>
            </div>
        )
    }
}

export default IotDevicesPage;


// WEBPACK FOOTER //
// ./src/containers/iot-devices-page.js